import type { Language } from '@seek/melways-sites';
import { getLanguagePrefixedPath } from './getLanguagePrefixedPath';

export const pathShouldNotRedirectToSignIn = (
  pathname: string,
  language?: Language,
) => {
  const paths = [
    getLanguagePrefixedPath(language, '/settings/notifications/unsubscribe'),
    getLanguagePrefixedPath(language, '/settings/notifications/resubscribe'),
  ];
  return paths.includes(pathname);
};
